<template>
  <div class="download-container">
    <!-- <img class="logo" src="https://via.placeholder.com/48" alt="logo" /> -->
     <!-- <div class="back_left" @click="$router.go(-1)" /> -->
    <img class="logo" src="../images/login/Snipaste2.png" alt="">
    <h2 class="bank-title">国家开发银行</h2>
    <div class="palace-welcome">推进精准扶贫 打赢脱贫攻坚战</div>
    <div class="desc">国开行走出开发性金融脱贫攻坚新路子</div>
    <img class="emblem" src="../images/user/11wh0-eeva3.png" alt="国徽" />
    <button class="download-btn" @click="goDownload">客户端下载</button>
    <div class="open-app">
      已安装？
      <a href="#" @click.prevent="openApp">点击返回</a>
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch'
export default {
  name: "CDBDownload",
  created() {
    this.$parent.footer('user', false);
  },
  methods: {

    goDownload() {
      // 跳转到官方APP下载页面
      Fetch('/user/system_info').then((r) => {
					// this.data = r.data;
          window.location.href = r.data.app;
					console.log(r.data);
					// this.kefu_link = u+'&visiter_name='+r.data.mobile+'&visiter_id='+r.data.uid+'&avatar='+r.data.user_icon
				});
      
    },
    openApp() {
      // 可根据实际APP的URL Scheme进行跳转
      // window.location.href = 'cdbapp://';
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.download-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: url(../images/user/8b4.jpg) no-repeat center;
	background-size: 112% 102%;
  max-width: 500px;
  /* border-radius: 18px; */
  text-align: center;
  padding: 62px 16px 24px 16px;
  color: #b22222;
  font-family: "微软雅黑", sans-serif;
}

.logo {
  width: 48px;
  margin-bottom: 12px;
}

.bank-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 18px;
}

.slogan {
  background: #fff6e5;
  color: #d82b2b;
  font-weight: bold;
  padding: 8px 0;
  margin-bottom: 8px;
  border-radius: 6px;
}

.desc {
  font-size: 15px;
  margin-bottom: 18px;
}

.emblem {
  width: 150px;
  margin: 50px 0;
}

.download-btn {
  background: #d82b2b;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 20px;
  padding: 12px 0;
  width: 60%;
  margin-bottom: 15px;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(216, 43, 43, 0.2);
}

.open-app {
  font-size: 14px;
  color: #7a2323;
}

.open-app a {
  color: #d82b2b;
  text-decoration: underline;
  margin-left: 4px;
}

.palace-welcome {
  margin-bottom: 18px;
  width: 300px;
  height: 50px;
  /* padding: 5px; */
  /* background: #9e2b27; */
  color: #e50113;
  border: 2px solid #e50113;
  border-radius: 5px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  font-family: "楷体", "STKaiti", serif;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.palace-welcome::before,
.palace-welcome::after {
  content: "★";
  color: #e50113;
  font-size: 15px;
  margin: 0 10px;
}

.palace-welcome::before {
  margin-right: 10px;
}

.palace-welcome::after {
  margin-left: 10px;
}
</style>